import React from 'react';
import { TableContainer, Paper, TableContainerProps } from '@material-ui/core';

import { useBreakpoints } from 'utils/hooks/UI';

const SearchListTableContainer: React.FC<TableContainerProps> = ({
  children,
  style,
  ...rest
}) => {
  const isMobile = !useBreakpoints().mdplus;

  const tableHeight = isMobile
    ? { height: '100%' }
    : {
        maxHeight: 'inherit',
      };

  return (
    <TableContainer
      component={Paper}
      {...rest}
      style={{ ...tableHeight, ...style }}
    >
      {children}
    </TableContainer>
  );
};

export default SearchListTableContainer;
